import React from 'react';

import { useIntl } from 'react-intl-next';

import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/core/success';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

type DefinitionUpdateConfirmationFlagType = {
	onDismissed: () => void;
};

export const DefinitionUpdateConfirmationFlag: React.FC<DefinitionUpdateConfirmationFlagType> = ({
	onDismissed,
}) => {
	const { formatMessage } = useIntl();

	return (
		<FlagGroup onDismissed={() => onDismissed()}>
			<AutoDismissFlag
				id="definition-update-success-adflag"
				title={formatMessage(messages.edit_definition_update_confirmation_title)}
				description={formatMessage(messages.edit_definition_update_confirmation_description)}
				icon={<SuccessIcon label="Success" color={token('color.icon.success')} />}
			/>
		</FlagGroup>
	);
};
